module.exports = "<div class=\"error\" *ngIf=\"hasErrorMessage\">\r\n    <ul>\r\n        <li *ngFor=\"let error of errorMessage\">{{error}}</li>\r\n    </ul>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/shared/validation-message.component.html
// module id = 2315
// module chunks = 1